module.exports = __webpack_public_path__ + "img/calendar.9d02ae9c.svg";